import React from "react";
import {
  ListSectionHeader,
  ListSectionHeaderDescription,
  ListSectionHeaderTitle,
} from "../../../components/atoms/ListSectionHeader";
import { FormattedMessage } from "react-intl";

export const KPIAdminTeamHeader = () => {
  return (
    <ListSectionHeader
      style={{ flexDirection: "column", alignItems: "flex-start" }}
    >
      <ListSectionHeaderTitle>
        <FormattedMessage
          defaultMessage="Select managing team"
          description="KPIAdminTeamHeader title"
        />
      </ListSectionHeaderTitle>
      <ListSectionHeaderDescription>
        <FormattedMessage
          defaultMessage="The managing team can monitor and overview KPI tracking from other teams."
          description="KPIAdminTeamHeader description"
        />
      </ListSectionHeaderDescription>
    </ListSectionHeader>
  );
};
